module.exports = __webpack_public_path__ + "static/drafted-e1a06fd75803e6534ce9ff94e1c35ebc.svg";